import Vue from 'vue'
import Dailog from './dailog.vue'

const constroller =Vue.extend(Dailog)

const  DailogComponent=(options)=>{
    options.callbackFun= options.callbackFun;
    const vm = new constroller({
        data:options
    })
    vm.$mount()
    document.body.appendChild(vm.$el)
    vm.visible = true
    return vm
}

export default DailogComponent